let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kWHNc")).then(() => parcelRequire('bv5Vu'));